// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import './util/hooks';

import { Swiper, Pagination, Navigation, Thumbs } from 'swiper';

Swiper.use([ Pagination, Navigation, Thumbs ]);

require('magnific-popup');

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

jQuery(document).ready(function() {
  jQuery(document).on('click', 'a[href^="#"]:not(.nav-link)', function (event) {
    event.preventDefault();

    jQuery('html, body').animate({
        scrollTop: jQuery(jQuery.attr(this, 'href')).offset().top,
    }, 500);
  });
  

  jQuery('.nav > li').click(function() {
    jQuery(this).toggleClass('dropdown-shown');
  });

  jQuery('.nav > li > a').click(function(e) {
      e.stopPropagation();
  });

  jQuery('.hamburger-button').click(function() {
      jQuery('.standard-navigation .nav').toggleClass('menu-shown');
  });

  jQuery('.cookie-notice .btn-accept').on('click', function() {
    setCookie('cookieNoticeAccepted', '1' , '7');

    jQuery('.cookie-notice').fadeOut(600, function() {
        jQuery('.cookie-notice').remove();
    });
  });
});

jQuery(window).on('load', function() {
    new Swiper(
        '.swiper-hero-cards-container', {
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
            el: '.swiper-hero-cards-container .swiper-pagination',
            clickable: true
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                allowTouchMove: false
            }
        },
        on: {
            init: () => {
                resizeHeroCards();
            }
        }
    });

    let mobileVideo = document.querySelector('.mobile-video');
    let desktopVideo = document.querySelector('.desktop-video');

    mobileVideo.autoplay = false;
    mobileVideo.pause();
    mobileVideo.currentTime = 0;
    mobileVideo.play();

    desktopVideo.autoplay = false;
    desktopVideo.pause();
    desktopVideo.currentTime = 0;
    desktopVideo.play();
});

jQuery(window).on('resize', function() {
    resizeHeroCards();
});

function resizeHeroCards() {
    let max = 0;

    jQuery('.swiper-hero-cards-container .hero-feature-card').each(function() {
        if (jQuery(this).height() > max) {
            jQuery(this).css('height', 'auto');

            max = jQuery(this).height();
        }
    });

    jQuery('.swiper-hero-cards-container .hero-feature-card').height(max);
}

window.onFirstUserInteraction = function() {
    if (jQuery('#map').length) {
        loadGoogleMaps();
    }

    new Swiper(
        '.swiper-posts-container', {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 30,
            loop: true,
            pagination: {
                el: '.swiper-posts-pagination',
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3
                }
            }
    });

    new Swiper(
        '.swiper-similiar-posts-container', {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 50,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                }
            }
    });

    equalizeServiceCards();
    equalizeBlogPostCards();

    jQuery('.search-wrapper input[type="submit"]').on('click', function(e) {
        if (jQuery('.search-wrapper').hasClass('closed')) {
            e.preventDefault();

            jQuery('.search-wrapper').removeClass('closed');
            jQuery('.paklog-navigation').addClass('search-open');
        }
    });

    jQuery(window).on('click', function() {
        jQuery('.search-wrapper').addClass('closed');
        jQuery('.paklog-navigation').removeClass('search-open');
    });

    jQuery('.paklog-navigation').on('click', function(e) {
        e.stopPropagation();
    });

    jQuery('.mobile-menu-toggle').on('click', function() {
        jQuery('.paklog-navigation').addClass('open');
        jQuery('body').addClass('overflow-hidden');
    });

    jQuery('.navigation-popup-wrapper .close-btn').on('click', function(e) {
        e.preventDefault();

        jQuery('.paklog-navigation').removeClass('open');
        jQuery('body').removeClass('overflow-hidden');
    });

    jQuery('.magnific-popup').magnificPopup({
        type:'image',
        gallery: {
            enabled: true
        }
    });

    jQuery(".modal").click(function(ev){
        if(ev.target != this) {
            return;
        }
        
        jQuery('.modal').modal('hide');
    });
}

function openIframeModal(link) {
    jQuery('#iframeModal iframe').attr('src', link);

    jQuery('#iframeModal').modal('show')
}

function equalizeServiceCards() {
    let isMobile = window.matchMedia("(max-width: 768px)")

    if (!isMobile.matches) {
        let max = 0;

        jQuery('.service-cards-with-banner .card-list .service-area-card .service-card-area-excerpt').each(function() {
            if (jQuery(this).height() > max) {
                max = jQuery(this).height();
            }
        });
    
        jQuery('.service-cards-with-banner .card-list .service-area-card .service-card-area-excerpt').each(function() {
            jQuery(this).height(max);
        });
    
        max = 0;
    
        jQuery('.service-cards-with-banner .card-list .service-area-card .service-area-card-title').each(function() {
            if (jQuery(this).height() > max) {
                max = jQuery(this).height();
            }
        });
    
        jQuery('.service-cards-with-banner .card-list .service-area-card .service-area-card-title').each(function() {
            jQuery(this).height(max);
        });
    }
}

function equalizeBlogPostCards() {
    let isMobile = window.matchMedia("(max-width: 768px)")

    if (!isMobile.matches) {
        let max = 0;

        jQuery('.blog-post-section .blog-post-card .blog-post-excerpt').each(function() {
            if (jQuery(this).height() > max) {
                max = jQuery(this).height();
            }
        });
    
        jQuery('.blog-post-section .blog-post-card .blog-post-excerpt').each(function() {
            jQuery(this).height(max);
        });
    
        max = 0;
    
        jQuery('.blog-post-section .blog-post-card .blog-post-title').each(function() {
            if (jQuery(this).height() > max) {
                max = jQuery(this).height();
            }
        });
    
        jQuery('.blog-post-section .blog-post-card .blog-post-title').each(function() {
            jQuery(this).height(max);
        });
    }
}

let mapStyle = null;
let map;
let markers = [];

function loadGoogleMaps() {
    jQuery.getJSON(window.localize.maps.stylePath, function(response) {
       mapStyle = response;

        jQuery.getScript( `https://maps.googleapis.com/maps/api/js?key=${window.localize.maps.apiKey}`, function() {
            initMap();
        });
    });
}

function initMap() {
    loadMap();
}

function loadMap() {
    let center = {lat: window.localize.maps.googleMapsLocation.lat, lng: window.localize.maps.googleMapsLocation.lng};

    map = new google.maps.Map(document.getElementById('map'), {
        zoom: window.localize.maps.googleMapsLocation.zoom,
        center: center,
        disableDefaultUI: false,
        styles: mapStyle
    });

    let markerImage = new google.maps.MarkerImage(
        window.localize.maps.iconPath,
        null,
        new google.maps.Point(0,0),
        new google.maps.Point(24,24)
    );

    let marker = new google.maps.Marker({
        position: {
            lat: center.lat,
            lng: center.lng
        },
        icon: markerImage,
        label: {
            text: window.localize.maps.markerText,
            className: 'marker-label'
        }
    });

    markers.push(marker);

    marker.setMap(map);
}

function setCookie(key, value, expiry) {
    let expires = new Date();

    expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));

    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
}


// WEBPACK FOOTER //
// ./scripts/main.js